<template>
  <div id="ourservice">
    <v-container fluid>
      <div data-aos="fade-up" data-aos-delay="300">
        <h1
          class="primary--text text-center my-10 mt-15"
          :style="
            this.$vuetify.breakpoint.mdAndUp ? 'font-size: 50px' : 'font-size: 40px'
          "
        >
          {{ $t("home.ourservice") }}
        </h1>
      </div>

      <v-row
        :style="
          this.$vuetify.breakpoint.mdAndUp
            ? 'width: 70%; margin: 0 auto'
            : 'width: 80%; margin: 0 auto'
        "
      >
        <v-col cols="12" sm="4" md="4">
          <div data-aos="flip-left" data-aos-delay="500">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card tile class="mx-auto">
                  <v-img :src="require('@/assets/ourservice/CampusTour.png')"></v-img>
                  <v-card-title class="font font-weight-black">
                    {{ $t("home.campustour") }}
                  </v-card-title>
                  <v-fade-transition>
                    <v-overlay v-if="hover" absolute color="white">
                      <v-btn :to="`/${$i18n.locale}/ourservice`" class="btn">
                        {{ $t("home.seemoreinfo") }}
                      </v-btn>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </div>
        </v-col>

        <v-col cols="12" sm="4" md="4">
          <div data-aos="flip-left" data-aos-delay="500">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card tile>
                  <v-img :src="require('@/assets/ourservice/KiriromTour.png')"> </v-img>
                  <v-card-title class="font font-weight-black">
                    {{ $t("home.kiriromtour") }}
                  </v-card-title>
                  <v-fade-transition>
                    <v-overlay v-if="hover" absolute color="white">
                      <v-btn :to="`/${$i18n.locale}/ourservice`" class="btn">
                        {{ $t("home.seemoreinfo") }}
                      </v-btn>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </div>
        </v-col>

        <v-col cols="12" sm="4" md="4">
          <div data-aos="flip-left" data-aos-delay="500">
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card tile>
                  <v-img :src="require('@/assets/ourservice/Pitching.png')"></v-img>
                  <v-card-title class="font font-weight-black">
                    {{ $t("home.pitch") }}
                  </v-card-title>
                  <v-fade-transition>
                    <v-overlay v-if="hover" absolute color="white">
                      <v-btn :to="`/${$i18n.locale}/ourservice`" class="btn">
                        {{ $t("home.seemoreinfo") }}
                      </v-btn>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "OurService",
  components: {},

  methods: {},

  data() {
    return {
      overlay: false,
      hover: false,
      fab: false,
    };
  },
};
</script>

<style scoped>
@media only screen and (min-width: 960px) {
  .font {
    font-size: 20px;
  }
}
@media only screen and (max-width: 960px) {
  .font {
    font-size: 17px;
  }

  .btn {
    font-size: 12px;
  }
}
</style>
